import { Injectable } from '@angular/core';
import { Action } from 'redux';
import { NgRedux } from '@angular-redux/store';
import { _UsersService } from './services/users.service';
import { IAppState} from './interfaces/appstate.interface';

@Injectable()
export class PermissionActions {
  static GET_USER_SETTINGS = 'GET_USER_SETTINGS';
  static GET_USER_ROLES = 'UPDATE_USER_ROLES';
  static GET_USER_RULES = 'UPDATE_USER_RULES';
  static ADD_TOKEN = 'ADD_TOKEN';
  // constructor( private users: _UsersService, private ngRedux: NgRedux<IAppState>) { }
  // updateUserSettings() {
  //   this.users.getUserRoles().subscribe((res)=>{
  //     this.ngRedux.dispatch(this.getUserSettings(res));
  //   })
  // }

  getUserSettings(payload) {
    return { type: PermissionActions.GET_USER_SETTINGS, payload };
  }

  getUserRoles(payload) {
    return { type: PermissionActions.GET_USER_ROLES, payload };
  }

  getUserRules(payload) {
    return { type: PermissionActions.GET_USER_RULES, payload };
  }
  addToken(payload) {
    return { type: PermissionActions.ADD_TOKEN, payload };
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/app.actions.ts